/**
 * FT14-U19: Write-Offs (FSD 2.2.3 "Propose Write-Off", FIN-F03-V06) and the write-off
 * approval thresholds.
 *
 * A per-feature route file; the INT packet spreads `AR_WRITE_OFF_ROUTES` into the router and
 * adds the nav items `ar-write-offs` (`/ar/write-offs`) and `ar-write-off-settings`
 * (`/ar/write-off-settings`), fsd 2.2.3. `/new` is declared before `/:id(\d+)` so `new` can
 * never be read as an id; the two document routes are drill-downs, not nav items.
 */

import type { RouteRecordRaw } from 'vue-router'

import { AR_WRITE_OFF_PERMISSIONS } from '@/modules/ar/write-offs/permissions'

export const AR_WRITE_OFF_ROUTES: RouteRecordRaw[] = [
  {
    path: '/ar/write-offs',
    name: 'ar-write-offs',
    component: () => import('@/modules/ar/write-offs/WriteOffsListView.vue'),
    meta: { titleKey: 'ar.routeTitles.writeOffs', permission: AR_WRITE_OFF_PERMISSIONS.read },
  },
  {
    path: '/ar/write-offs/new',
    name: 'ar-write-off-new',
    component: () => import('@/modules/ar/write-offs/WriteOffView.vue'),
    meta: { titleKey: 'ar.routeTitles.writeOffNew', permission: AR_WRITE_OFF_PERMISSIONS.propose },
  },
  {
    path: '/ar/write-offs/:id(\\d+)',
    name: 'ar-write-off',
    component: () => import('@/modules/ar/write-offs/WriteOffView.vue'),
    meta: { titleKey: 'ar.routeTitles.writeOff', permission: AR_WRITE_OFF_PERMISSIONS.read },
  },
  {
    path: '/ar/write-off-settings',
    name: 'ar-write-off-settings',
    component: () => import('@/modules/ar/write-offs/WriteOffSettingsView.vue'),
    meta: { titleKey: 'ar.routeTitles.writeOffSettings', permission: AR_WRITE_OFF_PERMISSIONS.read },
  },
]
